export const deliveryMethodVisibility = {
  public: 'public',
  internal: 'internal',
}
